import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=01d22381"
import script from "./selectProject.vue?vue&type=script&lang=js"
export * from "./selectProject.vue?vue&type=script&lang=js"
import style0 from "./selectProject.vue?vue&type=style&index=0&id=01d22381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports